// أقسام إضافية تُدمج مع سياسة الخصوصية — إفصاحات متاجر آبل وجوجل وجدول الاحتفاظ.
export const PRIVACY_EXTRA_AR = [
  {
    h: "12. إفصاح مسبق عن الأذونات الحسّاسة",
    p: [
      "قبل أول استخدام للكاميرا أو الموقع يظهر إشعار داخل التطبيق يوضّح الغرض، ثم يُطلب إذن النظام. رفض الإذن لا يمنعك من استخدام بقية التطبيق.",
      "الموقع يُقرأ «أثناء الاستخدام» فقط ولحظة تسجيل الحضور أو الانصراف فقط، ولا يوجد أي تتبّع في الخلفية ولا تجميع لمسار تحرّكك ولا مشاركة للموقع مع أي جهة إعلانية أو وسيط بيانات.",
      "لا يستخدم التطبيق أي معرّف إعلاني (IDFA/AAID)، ولا يتتبّعك عبر التطبيقات والمواقع، ولا يتضمّن أي شبكة إعلانات أو تحليلات سلوكية لأطراف ثالثة.",
    ],
  },
  {
    h: "13. جدول الاحتفاظ بالبيانات",
    p: [
      "بصمة الوجه (القالب الرقمي المحفوظ في مجموعة AWS Rekognition) والصورة المرجعية للتسجيل: تُحفظان حتى سحب الموافقة أو حذف الحساب أو إنهاء الاشتراك، ثم تُحذفان فوراً (حذف فعلي من Rekognition ومن قاعدة بياناتنا).",
      "صور التحقق اللحظية (إطارات الكاميرا عند كل تسجيل حضور/انصراف): لا نحتفظ بها إطلاقاً — تُرفع مؤقتاً برابط صالح 5 دقائق، تُقارَن، ثم تُحذف فوراً بعد انتهاء عملية التحقق. ولا تُحفظ صور جلسة كشف الحياة عندنا؛ يبقى لدينا رقم الجلسة ووقتها فقط.",
      "سجل محاولات التحقق: يحتوي نتيجة المحاولة (نجاح/فشل، درجة التشابه، درجة كشف الحياة، السبب) بلا أي صورة، ويُحفظ مع سجلات الحضور كسجل عمل.",
      "سجلات الخادم: سجلات الطلبات وعناوين IP 30 يوماً، سجلات الأخطاء وتنبيهات النظام 90 يوماً، الإشعارات 120 يوماً — ثم حذف تلقائي كل ليلة. رموز إشعارات الأجهزة تُحذف عند الخروج أو عند إبطال الرمز.",
      "سجلات الحضور والرواتب والشهادات الطبية والمستندات: طوال الاشتراك وبما تقتضيه الأنظمة المحلية (عادة 5–10 سنوات) لأنها سجلات عمل ومحاسبية. النسخ الاحتياطية تُستبدل دورياً ويكتمل الحذف منها خلال 35 يوماً كحد أقصى.",
    ],
  },
  {
    h: "14. المعالجون الفرعيون",
    p: [
      "Amazon Web Services (استضافة وتخزين S3، مطابقة الوجه وكشف الحياة Rekognition، إرسال البريد SES) · Google Firebase Cloud Messaging (إيصال الإشعارات فقط، بلا محتوى شخصي حسّاس) · ElevenLabs و OpenAI (يُرسل إليهما نص التحية الصوتية فقط — الاسم الأول والتحية، ومرة واحدة لكل موظف كتابة اسمه بالعربية للنطق — ولا يُرسل إليهما أي صورة ولا بصمة وجه ولا بيانات حضور أو راتب أو شهادات طبية) · Stripe (معالجة مدفوعات الشركات على الموقع فقط).",
      "يعمل كل معالج بموجب اتفاقية معالجة بيانات، ويُمنع عليه استخدام البيانات لأغراضه، وتُنشر أي إضافة أو تغيير في هذه القائمة قبل نفاذها.",
    ],
  },
  {
    h: "15. إفصاح أمان البيانات لمتاجر التطبيقات",
    p: [
      "البيانات التي تُجمع وتُرتبط بك: الاسم والبريد والهاتف والعنوان الفعلي، البيانات الصحية (الشهادات الطبية)، البيانات المالية (IBAN والراتب)، البيانات الحيوية (الوجه)، الموقع الدقيق لحظة التسجيل، الصور والملفات المرفوعة، بيانات الحضور، معرّف المستخدم ومعرّف إشعارات الجهاز، بيانات التفاعل مع التطبيق وسجلات الأداء والأخطاء الفنية.",
      "الغرض المُعلن لكل منها: «وظائف التطبيق» و«مكافحة الاحتيال والأمان» فقط. لا نجمع بيانات أعطال (Crash) عبر أي أداة طرف ثالث، ولا بيانات لأغراض الإعلانات أو تتبّع المعلنين أو التخصيص الإعلاني. لا نبيع البيانات ولا نشاركها مع وسطاء بيانات.",
      "كل البيانات تُنقل مشفَّرة، ويمكنك طلب حذف حسابك وبياناتك من داخل التطبيق أو عبر صفحة «حذف الحساب والبيانات» العامة.",
    ],
  },
  {
    h: "16. الإشعارات والاتصالات",
    p: [
      "نرسل إشعارات تشغيلية فقط: تذكير بالحضور والانصراف، قرارات الطلبات والإجازات، إشعارات المكافآت والعقوبات، وتنبيهات الأمان. لا نرسل إعلانات تسويقية عبر الإشعارات.",
      "يمكنك تعطيل الإشعارات من إعدادات الجهاز في أي وقت دون التأثير على باقي وظائف التطبيق.",
    ],
  },
  {
    h: "17. القرارات الآلية",
    p: [
      "تحويل اليوم إلى غياب عند عدم تسجيل الانصراف، وحساب الخصومات، يجريان بقواعد آلية معلنة مسبقاً وقابلة للمراجعة من صاحب العمل. لا يُتخذ أي قرار آلي بإنهاء الخدمة أو عقوبة نهائية دون تدخّل بشري من صاحب العمل.",
      "لك الحق في طلب مراجعة بشرية لأي احتساب آلي عبر صاحب العمل أو support@helcoo.uk.",
    ],
  },
];
